import ContentPopoverEmptyState from '../../../../draft-content-transplant/ContentPopoverEmptyState';
import { getNewSnippetsUrl } from '../../../../draft-transplant/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
const SnippetsPopoverEmptyState = ({
  portalId
}) => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "text-snippet",
  title: "draftPlugins.snippetsPlugin.popover.emptyState.title",
  description: "draftPlugins.snippetsPlugin.popover.emptyState.description",
  buttonLabel: "draftPlugins.snippetsPlugin.popover.emptyState.createFirstSnippet",
  buttonLink: getNewSnippetsUrl(portalId)
});
export default SnippetsPopoverEmptyState;